<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div>
      <Header />
    </div>

    <div class="bodyCenter">
      <div class="modalStyle">
        <div class="titulos">
          <div class="seccionTitle">
            <b-icon icon="people-fill" class="mLeft"></b-icon>
            <div class="headerTxt mLeft">Paciente</div>
          </div>

          <div class="alignIcon bold">
            PA_01_px
            <b-button to="/dashboard" variant="outline-primary">
              <b-icon icon="x"></b-icon>
            </b-button>
          </div>
        </div>

        <div class="noAlTope">
          <b-tabs>
            <b-tab title="Alta paciente" v-if="$localStorageService.can('PA_Alta_Px')">
              <altaPaciente :editar="false"/>
            </b-tab>
            <b-tab title="Editar paciente" v-if="$localStorageService.can('PA_Editar_Px')">
              <altaPaciente :editar="true" />
            </b-tab>
            <b-tab title="Actualizar paciente" v-if="$localStorageService.can('PA_01_tipo_subtipo_px')">
              <actualizarPaciente/>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Header from "../components/Header.vue";
import altaPaciente from "../components/paciente/AltaPaciente.vue";
import actualizarPaciente from "../components/paciente/ActualizarPaciente.vue";

export default {
  name: "PacienteCU",
  components: {
    Header,
    altaPaciente,
    actualizarPaciente
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  }
};
</script>

<style>
</style>